<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h5 class="text-primary">
          <i class="fas fa-equals" /> Totais
        </h5>
      </div>
    </div>

    <div class="row">
      <div class="col-7">
        <span>Total dos Produtos:</span>
      </div>
      <div class="col-5 text-right">
        <span style="padding-right:0.5rem">{{ productsTotal | decimal }}</span>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-5">
        <span>Acréscimo</span>
      </div>

      <div class="col-6 col-md-3 text-right">
        <number-input
          @keyup="calcUpdateValue('Addition')"
          v-model="dataAdditionPercent"
          :currencySymbol="' %'"
          :disabled="false"
        ></number-input>
      </div>
      <div class="col-6 col-md-4 text-right">
       <number-input @keyup="calcUpdatePercent('Addition')" v-model="dataAddition" :disabled="false"></number-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-5">
        <span>Desconto</span>
        <small v-if="maxDiscountAllowed" class="text-muted ml-2">(Max: {{ maxDiscountAllowed}}%)</small>
      </div>

      <div class="col-6 col-md-3 text-right">
        <number-input
          @keyup="calcUpdateValue('Discount')"
          v-model="dataDiscountPercent"
          :currencySymbol="' %'"
        ></number-input>
      </div>
      <div class="col-6 col-md-4 text-right">
        <number-input @keyup="calcUpdatePercent('Discount')" v-model="dataDiscount"></number-input>
      </div>
    </div>

    <div class="row" v-show="hasShipping">
      <div class="col-md-5">
        <span>Frete</span>
      </div>

      <div class="col-6 col-md-3 text-right" >
        <number-input
          @keyup="calcUpdateValue('Shipping')"
          v-model="dataShippingPercent"
          :currencySymbol="' %'"
        ></number-input>
      </div>
      <div class="col-6 col-md-4 text-right">
        <number-input @keyup="calcUpdatePercent('Shipping')" v-model="dataShipping" ></number-input>
      </div>
    </div>

    <div class="row">
      <div class="col-7">
        <span>Total da Venda</span>
      </div>
      <div class="col-5 text-right">
        <b class="text-primary" style="padding-right:0.5rem">{{ orderTotal | decimal }}</b>
      </div>
    </div>

    <div class="row mt-3" v-if="blockByMaximunDiscount">
      <div class="col-12">
        <b-alert
          :show="blockByMaximunDiscount"
          variant="danger"
        >O desconto concedido está acima do limite permitido para esta forma de pagamento!
        <br>
        (Máximo de {{ maxDiscountAllowed }}%).
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    operation : {},
    productsTotal: {},
    discount: {},
    addition: {},
    shipping: {},
    orderTotal: {},
    maxDiscountAllowed: {
      default: null
    },
    blockByMaximunDiscount: {
      default: false
    }
  },

  data: function() {
    return {
      dataDiscount: 0,
      dataAddition: 0,
      dataShipping: 0,
      dataDiscountPercent: 0,
      dataAdditionPercent: 0,
      dataShippingPercent: 0
    };
  },

  computed : {
    hasShipping() {
      return (this.operation == 1)
    },
  },

  watch: {
    discount(newValue) {
      this.dataDiscount = newValue;
      this.calcUpdatePercent("Discount");
    },

    addition(newValue) {
      this.dataAddition = newValue;
      this.calcUpdatePercent("Addition");
    },

    shipping(newValue) {
      this.dataShipping = newValue;
      this.calcUpdatePercent("Shipping");
    },

    productsTotal() {
      this.calcUpdateValue("Discount");
      this.calcUpdateValue("Addition");
      this.calcUpdateValue("Shipping");
    },

    dataDiscount(newValue) {
      this.$emit("discountUpdated", newValue);
    },
    dataAddition(newValue) {
      this.$emit("additionUpdated", newValue);
    },
    dataShipping(newValue) {
      this.$emit("shippingUpdated", newValue);
    }
  },

  methods: {
    calcUpdatePercent(field) {
      if (this.productsTotal != 0) {
        this["data" + field + "Percent"] =
          (this["data" + field] * 100) / this.productsTotal;
        return;
      }
    },

    calcUpdateValue(field) {
      this["data" + field] =
        Math.round(
          this.productsTotal * (this["data" + field + "Percent"] / 100) * 100
        ) / 100;
    },
    reset() {
      this.dataDiscount = 0;
      this.dataAddition = 0;
      this.dataShipping = 0;
      this.dataDiscountPercent = 0;
      this.dataAdditionPercent = 0;
      this.dataShippingPercent = 0;
    }
  }
};
</script>

<style>
</style>